import { render, staticRenderFns } from "./ProjectStatusIndicator.vue?vue&type=template&id=38f239f3"
import script from "./ProjectStatusIndicator.vue?vue&type=script&lang=js"
export * from "./ProjectStatusIndicator.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatusIndicator.vue?vue&type=style&index=0&id=38f239f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports